import {h} from "preact";
import s from "./product.module.css";
import {useAppContext, useUserContext} from "../../../../../../contexts";
import ProductActions from "./ProductActions";

const Product = props => {
    // Destructured props
    const {
        item,
        updateCart,
        incrementDisable
    } = props;

    // Retrieves the cart data from the user context
    const [{}, {}, {cartData}] = useUserContext();

    // The message for when it's a home delivery product
    // const zipMessage = item.cep && ` - CEP: ${item.cep}`;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // CRUD product actions
    const productActions = !cartData["nadLock"] ? (
        <ProductActions
            updateCart={updateCart}
            item={item}
            incrementDisable={incrementDisable}
        />
    ) : null;

    return (
        <li className={`${s.root} ${(!cartData["nadLock"] ? "pb-3" : "pb-2")}`}>
            <div className={`w-full flex flex-row justify-between items-center gap-x-4 ${highContrast ? "highLabelFirst" : ""}`}>
                <h1 className={`font-museo text-ellipsis overflow-hidden ${s.productName}`}>
                    {item.name}
                </h1>
                <div className={"flex flex-row justify-between items-center gap-x-4 shrink-0"}>
                    {productActions}
                    <p className={s.price}>
                        <span className={`${highContrast ? "highTitleThird" : ""}`}>
                            R$&nbsp;
                        </span>
                        {item.total}
                    </p>
                </div>
            </div>
            {/*<div className={"w-full flex flex-row justify-between gap-x-8"}>*/}
            {/*    <p className={s.attendance}>*/}
            {/*        {item.unity}{zipMessage}*/}
            {/*    </p>*/}

            {/*    /!* In case it's a home delivery attendance type *!/*/}
            {/*    <p className={`${s.price} hidden`}>*/}
            {/*        <span className={"text-sabin-red-default"}>*/}
            {/*            R$&nbsp;*/}
            {/*        </span>*/}
            {/*        {item.price}*/}
            {/*    </p>*/}
            {/*</div>*/}
        </li>
    )
}

export default Product;
